const zwds = {
  zwds: {
    // Palace names
    palaces: {
      命宫: "命宫",
      兄弟: "兄弟宫",
      夫妻: "夫妻宫",
      子女: "子女宫",
      财帛: "财帛宫",
      疾厄: "疾厄宫",
      迁移: "迁移宫",
      交友: "交友宫",
      官禄: "官禄宫",
      田宅: "田宅宫",
      福德: "福德宫",
      父母: "父母宫",
    },

    // Heavenly Stems
    stems: {
      甲: "甲",
      乙: "乙",
      丙: "丙",
      丁: "丁",
      戊: "戊",
      己: "己",
      庚: "庚",
      辛: "辛",
      壬: "壬",
      癸: "癸",
    },

    // Earthly Branches
    branches: {
      子: "子（鼠）",
      丑: "丑（牛）",
      寅: "寅（虎）",
      卯: "卯（兔）",
      辰: "辰（龙）",
      巳: "巳（蛇）",
      午: "午（马）",
      未: "未（羊）",
      申: "申（猴）",
      酉: "酉（鸡）",
      戌: "戌（狗）",
      亥: "亥（猪）",
    },

    // Month Heavenly Stems
    monthBranches: {
      子: "1",
      丑: "2",
      寅: "3",
      卯: "4",
      辰: "5",
      巳: "6",
      午: "7",
      未: "8",
      申: "9",
      酉: "10",
      戌: "11",
      亥: "12",
    },

    // Day Heavenly Stems
    dayBranches: {
      子: "子",
      丑: "丑",
      寅: "寅",
      卯: "卯",
      辰: "辰",
      巳: "巳",
      午: "午",
      未: "未",
      申: "申",
      酉: "酉",
      戌: "戌",
      亥: "亥",
    },

    // Main stars
    mainStars: {
      紫微: "紫微星",
      天机: "天机星",
      太阳: "太阳星",
      武曲: "武曲星",
      天同: "天同星",
      廉贞: "廉贞星",
      天府: "天府星",
      太阴: "太阴星",
      贪狼: "贪狼星",
      巨门: "巨门星",
      天相: "天相星",
      天梁: "天梁星",
      七杀: "七杀星",
      破军: "破军星",
    },

    // Transformations
    transformations: {
      化科: "化科",
      化权: "化权",
      化禄: "化禄",
      化忌: "化忌",
    },

    // Minor stars
    minorStars: {
      文昌: "文昌星",
      文曲: "文曲星",
      左辅: "左辅星",
      右弼: "右弼星",
      天魁: "天魁星",
      天钺: "天钺星",
      天厨: "天厨星",
      天刑: "天刑星",
      天姚: "天姚星",
      天喜: "天喜星",
      地空: "地空星",
      地劫: "地劫星",
      火星: "火星",
      铃星: "铃星",
    },

    // Five Elements
    fiveElements: {
      水二局: "水二局",
      木三局: "木三局",
      金四局: "金四局",
      土五局: "土五局",
      火六局: "火六局",
    },

    // Chart sections
    chart: {
      年: "年",
      月: "月",
      日: "日",
      时: "时",
      生肖: "生肖",
      五行: "五行",
      阳历: "阳历",
      阴历: "阴历",
      男: "男",
      女: "女",
      命主: "命主",
      身主: "身主",
      大限: "大限",
      小限: "小限",
      流年: "流年",
      age: "年龄",
      westernZodiac: "西方生肖",
      陰: "阴",
      陽: "阳",
      歲: "岁",
    },
    lunarDays: {
      初一: "1",
      初二: "2",
      初三: "3",
      初四: "4",
      初五: "5",
      初六: "6",
      初七: "7",
      初八: "8",
      初九: "9",
      初十: "10",
      十一: "11",
      十二: "12",
      十三: "13",
      十四: "14",
      十五: "15",
      十六: "16",
      十七: "17",
      十八: "18",
      十九: "19",
      二十: "20",
      廿一: "21",
      廿二: "22",
      廿三: "23",
      廿四: "24",
      廿五: "25",
      廿六: "26",
      廿七: "27",
      廿八: "28",
      廿九: "29",
      三十: "30",
      三十一: "31",
    },

    zodiac: {
      鼠: "鼠",
      牛: "牛",
      虎: "虎",
      兔: "兔",
      龙: "龙",
      蛇: "蛇",
      马: "马",
      羊: "羊",
      猴: "猴",
      鸡: "鸡",
      狗: "狗",
      猪: "猪",
    },

    westernZodiac: {
      aries: "白羊座",
      taurus: "金牛座",
      gemini: "双子座",
      cancer: "巨蟹座",
      leo: "狮子座",
      virgo: "处女座",
      libra: "天秤座",
      scorpio: "天蝎座",
      sagittarius: "射手座",
      capricorn: "摩羯座",
      aquarius: "水瓶座",
      pisces: "双鱼座",
    },
  },
};

export default zwds;
